import { render } from "./two-column-pitch.vue?vue&type=template&id=59ca096a&scoped=true&ts=true"
import script from "./two-column-pitch.vue?vue&type=script&lang=ts"
export * from "./two-column-pitch.vue?vue&type=script&lang=ts"

import "./two-column-pitch.vue?vue&type=style&index=0&id=59ca096a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ca096a"]])

export default __exports__